import type { ComponentType } from "react";
import { CalendarPlus, TelegramLogo, WhatsappLogo } from "@phosphor-icons/react/dist/ssr";

import { paths } from "@/src/routes/paths";

export interface ChatLauncherActionData {
  label: string;
  href: string;
  icon: ComponentType<{ size?: number; weight?: "bold" | "regular" | "fill"; className?: string }>;
}

// Render (and visual, top-to-bottom) order — closest to the toggle button
// last, matching the outward-cascading stagger delay in ChatLauncher.tsx.
export const CHAT_LAUNCHER_ACTIONS: ChatLauncherActionData[] = [
  // { label: "Contact us via Telegram", href: paths.telegramURL, icon: TelegramLogo },
  { label: "Contact us via WhatsApp", href: paths.whatsAppURL, icon: WhatsappLogo },
  { label: "Book a call", href: paths.bookACall, icon: CalendarPlus },
];
